import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from './chatEmpty.module.scss'

import { ReactComponent as EmptyChatIcon } from './icons/chat_empty_icon.svg'
import { ReactComponent as OperatorSvg } from '../../../../assets/icons/operator.svg'
import { setIsSupportOpenedAction } from '../../../../redux/support/support.action'
import Button from '../../../../UI/Button/Button'
import InfoModal from '../../../InfoModal/InfoModal'

const ChatEmpty = () => {
  const dispatch = useDispatch()
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)
  const isProfileActive = useSelector(({ company }) => company.is_active)
  const emptyChatText = isProfileActive
    ? 'You dont have messages yet'
    : "You can't use chat until your activation and moderation is completed. Yet you still can write to support"

  return (
    <div className={styles.block}>
      <div className={styles.content}>
        <EmptyChatIcon className={styles.icon} />

        <div className={styles.textContent}>
          <h3 className={styles.textContentTitle}>{emptyChatText}</h3>
        </div>

        {!isProfileActive && (
          <div className={styles.actions}>
            <Button
              type="button"
              size="middle"
              className={styles.actionButton}
              onClick={() => setIsInfoModalOpen(true)}
            >
              Moderation
            </Button>

            <Button
              type="button"
              size="middle"
              className={styles.actionButton}
              onClick={() => dispatch(setIsSupportOpenedAction(true))}
            >
              <OperatorSvg className={styles.supportIcon} />
              Support
            </Button>
          </div>
        )}
      </div>

      {isInfoModalOpen && <InfoModal onClose={() => setIsInfoModalOpen(false)} />}
    </div>
  )
}

export default ChatEmpty
